import React from 'react';
import {
  Button,
  Form,
  Modal,
} from "react-bootstrap"

const Popup = ({
  row,
  onChange,
  onApplyChanges,
  onCancelChanges,
  open,
}) => {
  return (
    <Modal
      show={open}
      onHide={onCancelChanges}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title>Scope Form</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label>Scope Name</Form.Label>
            <Form.Control
              name="SCOPE_NAME"
              value={row.SCOPE_NAME}
              onChange={onChange}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label>Status</Form.Label>
            <Form.Control as="select"
              name="SCOPE_STATUS"
              onChange={onChange}
            >
              <option value={-1}>Select Status...</option>
              <option value="Active" selected={ row.SCOPE_STATUS == 'Active' ? true : false }  >Active</option>
              <option value="InActive" selected={ row.SCOPE_STATUS == 'InActive' ? true : false }>InActive</option>
              
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onCancelChanges}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onApplyChanges}>Save</Button>
      </Modal.Footer>
    </Modal>
  )
};

export default Popup;